/**
 * @module ol/format/FormatType
 */

/**
 * @enum {string}
 */
export default {
  ARRAY_BUFFER: 'arraybuffer',
  JSON: 'json',
  TEXT: 'text',
  XML: 'xml'
};

//# sourceMappingURL=FormatType.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ol/format/FormatType.js
// module id = 205
// module chunks = 0